import { ref as E, computed as N, watch as x, onMounted as Z, openBlock as $, createBlock as ee, unref as t, withCtx as k, createVNode as d, createElementVNode as w, toDisplayString as Y, nextTick as O, createElementBlock as g, Fragment as B, renderList as V, normalizeClass as ne, createTextVNode as le, getCurrentInstance as re } from "vue";
import { DtIconChevronsLeft as oe, DtIconChevronLeft as se, DtIconChevronRight as ue, DtIconChevronsRight as ie } from "@dialpad/dialtone-icons/vue3";
import { getMonth as G, getYear as q, subMonths as j, endOfMonth as J, startOfDay as L, addMonths as Q, startOfMonth as W, getDate as ce, set as de } from "date-fns";
import { getCalendarDays as fe, formatMonth as De, getWeekDayNames as ve, calculateNextFocusDate as me, calculatePrevFocusDate as ke, formatDate as be } from "./utils.js";
import { INTL_MONTH_FORMAT as te } from "./datepicker-constants.js";
import { returnFirstEl as v, warnIfUnmounted as pe } from "../../common/utils/index.js";
import { DialtoneLocalization as U } from "../../localization/index.js";
import R from "../stack/stack.js";
import P from "../tooltip/tooltip.js";
import I from "../button/button.js";
function ye(n, o) {
  const u = E(G(n.selectedDate)), a = E(q(n.selectedDate)), l = E(null), r = E(0), m = E([]), D = new U(), h = N(() => fe(
    u.value,
    a.value,
    l.value,
    n.minDate,
    n.maxDate,
    n.weekStartsOn
  )), b = N(() => {
    if (!n.minDate) return !1;
    const e = j(new Date(a.value, u.value, 1), 1);
    return J(e) < L(n.minDate);
  }), _ = N(() => {
    if (!n.maxDate) return !1;
    const e = Q(new Date(a.value, u.value, 1), 1);
    return W(e) > L(n.maxDate);
  }), p = N(() => {
    if (!n.minDate) return !1;
    const e = new Date(a.value - 1, u.value, 1);
    return J(e) < L(n.minDate);
  }), T = N(() => {
    if (!n.maxDate) return !1;
    const e = new Date(a.value + 1, u.value, 1);
    return W(e) > L(n.maxDate);
  });
  x(u, () => {
    M(), o("calendar-days", h.value);
  }, { immediate: !0 }), x(a, () => {
    M(), o("calendar-days", h.value);
  }, { immediate: !0 }), x(() => n.minDate, () => {
    o("calendar-days", h.value);
  }), x(() => n.maxDate, () => {
    o("calendar-days", h.value);
  });
  function s(e) {
    return De(e, te, D.currentLocale);
  }
  function i(e) {
    m.value.includes(e) || m.value.push(e);
  }
  function A() {
    v(m.value[0].$el).focus();
  }
  function f(e) {
    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault(), r.value === 0 ? (r.value = 3, v(m.value[r.value].$el).focus()) : (r.value--, v(m.value[r.value].$el).focus());
        break;
      case "ArrowRight":
        e.preventDefault(), r.value === 3 ? (r.value = 0, v(m.value[r.value].$el).focus()) : (r.value++, v(m.value[r.value].$el).focus());
        break;
      case "ArrowDown":
        e.preventDefault(), o("focus-first-day");
        break;
      case "Tab":
        e.preventDefault(), o("focus-first-day");
        break;
      case "Escape":
        o("close-datepicker");
        break;
    }
  }
  function M() {
    const e = q(n.selectedDate), C = G(n.selectedDate);
    e !== a.value || C !== u.value ? l.value = null : l.value = ce(n.selectedDate);
  }
  function y(e) {
    if (e === -1 && b.value || e === 1 && _.value) return;
    (u.value === 0 && e === -1 || u.value === 11 && e === 1) && (a.value += e);
    const C = de(n.selectedDate, { month: u.value, year: a.value }), ae = e === 1 ? Q(C, 1) : j(C, 1);
    u.value = G(ae);
  }
  function K(e) {
    e === -1 && p.value || e === 1 && T.value || (a.value = a.value + e);
  }
  function S() {
    y(1);
  }
  function F() {
    y(-1);
  }
  function z() {
    return `${D.$t("DIALTONE_DATEPICKER_CHANGE_TO")} ${D.$t("DIALTONE_DATEPICKER_PREVIOUS_YEAR")} ${a.value - 1}`;
  }
  function H() {
    return `${D.$t("DIALTONE_DATEPICKER_CHANGE_TO")} ${D.$t("DIALTONE_DATEPICKER_PREVIOUS_MONTH")} ${s(u.value - 1)}`;
  }
  function X() {
    return `${D.$t("DIALTONE_DATEPICKER_CHANGE_TO")} ${D.$t("DIALTONE_DATEPICKER_NEXT_YEAR")} ${a.value + 1}`;
  }
  function c() {
    return `${D.$t("DIALTONE_DATEPICKER_CHANGE_TO")} ${D.$t("DIALTONE_DATEPICKER_NEXT_MONTH")} ${s(u.value + 1)}`;
  }
  return {
    selectMonth: u,
    selectYear: a,
    formattedMonth: s,
    setDayRef: i,
    focusMonthYearPicker: A,
    handleKeyDown: f,
    changeMonth: y,
    changeYear: K,
    goToNextMonth: S,
    goToPrevMonth: F,
    isPrevMonthDisabled: b,
    isNextMonthDisabled: _,
    isPrevYearDisabled: p,
    isNextYearDisabled: T,
    previousYearAriaLabel: z,
    previousMonthAriaLabel: H,
    nextYearAriaLabel: X,
    nextMonthAriaLabel: c
  };
}
const he = {
  id: "calendar-heading",
  class: "d-datepicker__month-year-title"
}, _e = {
  __name: "month-year-picker",
  props: {
    selectedDate: {
      type: Date,
      required: !0
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    weekStartsOn: {
      type: Number,
      default: 0,
      validator: (n) => Number.isInteger(n) && n >= 0 && n <= 6
    }
  },
  emits: [
    /**
       * Will retrieve the calendar days of the given date
       *
       * @event calendar-days
       * @type {Array}
       */
    "calendar-days",
    /**
       * Will focus first day in calendar
       *
       * @event focus-first-day
       */
    "focus-first-day",
    /**
       * Will focus last day in calendar
       *
       * @event focus-last-day
       */
    "focus-last-day",
    /**
       * Will close the datepicker
       *
       * @event close-datepicker
       */
    "close-datepicker"
  ],
  setup(n, { expose: o, emit: u }) {
    const a = n, l = u, r = new U(), {
      selectMonth: m,
      selectYear: D,
      formattedMonth: h,
      setDayRef: b,
      focusMonthYearPicker: _,
      handleKeyDown: p,
      changeMonth: T,
      changeYear: s,
      goToNextMonth: i,
      goToPrevMonth: A,
      isPrevMonthDisabled: f,
      isNextMonthDisabled: M,
      isPrevYearDisabled: y,
      isNextYearDisabled: K,
      previousYearAriaLabel: S,
      previousMonthAriaLabel: F,
      nextMonthAriaLabel: z,
      nextYearAriaLabel: H
    } = ye(a, l);
    return Z(() => {
      _();
    }), o({
      focusMonthYearPicker: _,
      goToNextMonth: i,
      goToPrevMonth: A
    }), (X, c) => ($(), ee(t(R), {
      class: "d-datepicker__month-year",
      direction: "row",
      gap: "300"
    }, {
      default: k(() => [
        d(t(R), {
          as: "nav",
          class: "d-datepicker__nav",
          direction: "row",
          gap: "200"
        }, {
          default: k(() => [
            d(t(P), {
              "fallback-placements": ["top-start", "auto"],
              message: t(r).$t("DIALTONE_DATEPICKER_PREVIOUS_YEAR"),
              placement: "top"
            }, {
              anchor: k(() => [
                d(t(I), {
                  id: "prevYearButton",
                  ref: (e) => {
                    e && t(b)(e);
                  },
                  "aria-label": t(S)(),
                  circle: !0,
                  disabled: t(y),
                  class: "d-datepicker__nav-btn",
                  importance: "clear",
                  kind: "muted",
                  size: "xs",
                  type: "button",
                  onClick: c[0] || (c[0] = (e) => t(s)(-1)),
                  onKeydown: c[1] || (c[1] = (e) => t(p)(e))
                }, {
                  default: k(() => [
                    d(t(oe), { size: "200" })
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled"])
              ]),
              _: 1
            }, 8, ["message"]),
            d(t(P), {
              "fallback-placements": ["top-start", "auto"],
              message: t(r).$t("DIALTONE_DATEPICKER_PREVIOUS_MONTH"),
              placement: "top"
            }, {
              anchor: k(() => [
                d(t(I), {
                  id: "prevMonthButton",
                  ref: (e) => {
                    e && t(b)(e);
                  },
                  "aria-label": t(F)(),
                  circle: !0,
                  disabled: t(f),
                  class: "d-datepicker__nav-btn",
                  importance: "clear",
                  kind: "muted",
                  size: "xs",
                  type: "button",
                  onClick: c[2] || (c[2] = (e) => t(T)(-1)),
                  onKeydown: c[3] || (c[3] = (e) => t(p)(e))
                }, {
                  default: k(() => [
                    d(t(se), { size: "200" })
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled"])
              ]),
              _: 1
            }, 8, ["message"])
          ]),
          _: 1
        }),
        w("div", he, Y(t(h)(t(m))) + " " + Y(t(D)), 1),
        d(t(R), {
          as: "nav",
          class: "d-datepicker__nav",
          direction: "row",
          gap: "200"
        }, {
          default: k(() => [
            d(t(P), {
              "fallback-placements": ["top-end", "auto"],
              message: t(r).$t("DIALTONE_DATEPICKER_NEXT_MONTH"),
              placement: "top"
            }, {
              anchor: k(() => [
                d(t(I), {
                  id: "nextMonthButton",
                  ref: (e) => {
                    e && t(b)(e);
                  },
                  "aria-label": t(z)(),
                  circle: !0,
                  disabled: t(M),
                  class: "d-datepicker__nav-btn",
                  importance: "clear",
                  kind: "muted",
                  size: "xs",
                  type: "button",
                  onClick: c[4] || (c[4] = (e) => t(T)(1)),
                  onKeydown: c[5] || (c[5] = (e) => t(p)(e))
                }, {
                  default: k(() => [
                    d(t(ue), { size: "200" })
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled"])
              ]),
              _: 1
            }, 8, ["message"]),
            d(t(P), {
              "fallback-placements": ["top-end", "auto"],
              message: t(r).$t("DIALTONE_DATEPICKER_NEXT_YEAR"),
              placement: "top"
            }, {
              anchor: k(() => [
                d(t(I), {
                  id: "nextYearButton",
                  ref: (e) => {
                    e && t(b)(e);
                  },
                  "aria-label": t(H)(),
                  circle: !0,
                  disabled: t(K),
                  class: "d-datepicker__nav-btn",
                  importance: "clear",
                  kind: "muted",
                  size: "xs",
                  type: "button",
                  onClick: c[6] || (c[6] = (e) => t(s)(1)),
                  onKeydown: c[7] || (c[7] = (e) => t(p)(e))
                }, {
                  default: k(() => [
                    d(t(ie), { size: "200" })
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled"])
              ]),
              _: 1
            }, 8, ["message"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
};
function $e(n, o) {
  const u = E(null), a = E(0), l = E([]), r = new U(), m = N(() => ve(n.locale, n.weekStartsOn));
  x(() => n.calendarDays, () => {
    a.value = 0, l.value = [], u.value = null;
  });
  function D(s) {
    return r.$t("DIALTONE_DATEPICKER_SELECT_DAY") + ` ${be(s.value, te, r.currentLocale)}`;
  }
  function h(s, i) {
    !l.value.some((A) => A.el === s) && !i.disabled && l.value.push({ el: s, day: i });
  }
  function b(s) {
    switch (s.key) {
      case "ArrowUp":
        s.preventDefault(), a.value -= 7;
        try {
          v(l.value[a.value].el.$el).focus();
        } catch {
          const i = ke(l.value[a.value + 7].day.value);
          o("go-to-prev-month"), O(() => {
            v(l.value[i - 1].el.$el).focus(), a.value += i - 1;
          });
        }
        break;
      case "ArrowDown":
        s.preventDefault(), a.value += 7;
        try {
          v(l.value[a.value].el.$el).focus();
        } catch {
          const i = me(l.value[a.value - 7].day.value);
          o("go-to-next-month"), O(() => {
            v(l.value[i - 1].el.$el).focus(), a.value += i - 1;
          });
        }
        break;
      case "ArrowLeft":
        s.preventDefault(), a.value > 0 ? (a.value -= 1, v(l.value[a.value].el.$el).focus()) : (o("go-to-prev-month"), p());
        break;
      case "ArrowRight":
        s.preventDefault(), a.value < l.value.length - 1 ? (a.value += 1, v(l.value[a.value].el.$el).focus()) : (o("go-to-next-month"), _());
        break;
      case "Tab":
        s.preventDefault(), o("focus-month-year-picker");
        break;
      case "Escape":
        o("close-datepicker");
        break;
    }
  }
  function _() {
    a.value = 0, O(() => {
      v(l.value[a.value].el.$el).focus();
    });
  }
  function p() {
    O(() => {
      a.value = l.value.length - 1, v(l.value[a.value].el.$el).focus();
    });
  }
  function T(s) {
    s.disabled || (u.value = s.text, o("select-date", s.value));
  }
  return {
    selectedDay: u,
    weekDays: m,
    dayAriaLabel: D,
    setDayRef: h,
    handleKeyDown: b,
    focusFirstDay: _,
    selectDay: T
  };
}
const Ee = {
  class: "d-datepicker__calendar",
  "aria-labelledby": "calendar-heading"
}, Te = ["title", "aria-label"], Ae = {
  __name: "calendar",
  props: {
    calendarDays: {
      type: Array,
      required: !0
    },
    weekStartsOn: {
      type: Number,
      default: 0,
      validator: (n) => Number.isInteger(n) && n >= 0 && n <= 6
    }
  },
  emits: [
    /**
       * Event fired when a date is selected
       *
       * @event select-date
       * @type {Date}
       */
    "select-date",
    /**
       * Will focus the month and year picker
       *
       * @event focus-month-year-picker
       */
    "focus-month-year-picker",
    /**
       * Will close the datepicker
       *
       * @event close-datepicker
       */
    "close-datepicker",
    /**
       * Will go to the next month
       *
       * @event go-to-next-month
       */
    "go-to-next-month",
    /**
       * Will go to the previous month
       *
       * @event go-to-prev-month
       */
    "go-to-prev-month"
  ],
  setup(n, { expose: o, emit: u }) {
    const a = n, l = u, {
      selectedDay: r,
      weekDays: m,
      dayAriaLabel: D,
      setDayRef: h,
      handleKeyDown: b,
      focusFirstDay: _,
      selectDay: p
    } = $e(a, l);
    return o({
      focusFirstDay: _
    }), (T, s) => ($(), g("table", Ee, [
      w("thead", null, [
        w("tr", null, [
          ($(!0), g(B, null, V(t(m), (i) => ($(), g("th", {
            key: i,
            scope: "col",
            class: "d-datepicker__cell d-datepicker__cell--header"
          }, [
            w("span", {
              class: "d-datepicker__weekday",
              title: i,
              "aria-label": i
            }, Y(i), 9, Te)
          ]))), 128))
        ])
      ]),
      w("tbody", null, [
        ($(!0), g(B, null, V(n.calendarDays, (i, A) => ($(), g("tr", { key: A }, [
          ($(!0), g(B, null, V(i.days, (f, M) => ($(), g("td", {
            key: A + M,
            class: "d-datepicker__cell",
            role: "listbox"
          }, [
            d(t(I), {
              ref_for: !0,
              ref: (y) => {
                y && t(h)(y, f);
              },
              class: ne(["d-datepicker__day", {
                "d-datepicker__day--disabled": f.disabled,
                "d-datepicker__day--selected": t(r) ? f.text === t(r) && !f.disabled : f.selected
              }]),
              circle: !0,
              size: "sm",
              importance: "clear",
              disabled: f.disabled,
              type: "button",
              "aria-selected": t(r) ? f.text === t(r) && !f.disabled : f.selected,
              "aria-label": t(D)(f),
              role: "option",
              onClick: (y) => t(p)(f),
              onKeydown: s[0] || (s[0] = (y) => t(b)(y))
            }, {
              default: k(() => [
                le(Y(f.text), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "class", "aria-selected", "aria-label", "onClick"])
          ]))), 128))
        ]))), 128))
      ])
    ]));
  }
}, ge = { class: "d-datepicker__hd" }, we = { class: "d-datepicker__bd" }, Ke = {
  __name: "datepicker",
  props: {
    /**
       * Selected date
       *
       * @type {Date}
       */
    selectedDate: {
      type: Date,
      default: () => /* @__PURE__ */ new Date()
    },
    /**
       * Minimum selectable date. Days before this date will be disabled.
       * Must be before or equal to maxDate when both are provided.
       *
       * @type {Date}
       */
    minDate: {
      type: Date,
      default: null
    },
    /**
       * Maximum selectable date. Days after this date will be disabled.
       * Must be after or equal to minDate when both are provided.
       *
       * @type {Date}
       */
    maxDate: {
      type: Date,
      default: null,
      validator: (n, o) => n && o.minDate && n < o.minDate ? (console.warn("[DtDatepicker]: maxDate must be after or equal to minDate."), !1) : !0
    },
    /**
       * Day the week starts on. 0 = Sunday, 1 = Monday, ... 6 = Saturday.
       *
       * @values 0, 1, 2, 3, 4, 5, 6
       */
    weekStartsOn: {
      type: Number,
      default: 0,
      validator: (n) => Number.isInteger(n) && n >= 0 && n <= 6
    }
  },
  emits: [
    /**
       * Event fired when a date is selected
       *
       * @event selected-date
       * @type {Date}
       */
    "selected-date",
    /**
       * Event fired when user presses the esc key
       *
       * @event close-datepicker
       */
    "close-datepicker"
  ],
  setup(n) {
    const o = E([]);
    function u(a) {
      o.value = a;
    }
    return Z(() => {
      const a = re();
      pe(v(a.proxy.$el), "datepicker");
    }), (a, l) => ($(), ee(t(R), {
      class: "d-datepicker",
      gap: "400"
    }, {
      default: k(() => [
        w("div", ge, [
          d(_e, {
            ref: "monthYearPicker",
            "selected-date": n.selectedDate,
            "min-date": n.minDate,
            "max-date": n.maxDate,
            "week-starts-on": n.weekStartsOn,
            onCalendarDays: u,
            onFocusFirstDay: l[0] || (l[0] = (r) => a.$refs.calendar.focusFirstDay()),
            onFocusLastDay: l[1] || (l[1] = (r) => a.$refs.calendar.focusLastDay()),
            onCloseDatepicker: l[2] || (l[2] = (r) => a.$emit("close-datepicker"))
          }, null, 8, ["selected-date", "min-date", "max-date", "week-starts-on"])
        ]),
        w("div", we, [
          d(Ae, {
            ref: "calendar",
            "calendar-days": o.value,
            "week-starts-on": n.weekStartsOn,
            onSelectDate: l[3] || (l[3] = (r) => a.$emit("selected-date", r)),
            onFocusMonthYearPicker: l[4] || (l[4] = (r) => a.$refs.monthYearPicker.focusMonthYearPicker()),
            onCloseDatepicker: l[5] || (l[5] = (r) => a.$emit("close-datepicker")),
            onGoToNextMonth: l[6] || (l[6] = (r) => a.$refs.monthYearPicker.goToNextMonth()),
            onGoToPrevMonth: l[7] || (l[7] = (r) => a.$refs.monthYearPicker.goToPrevMonth())
          }, null, 8, ["calendar-days", "week-starts-on"])
        ])
      ]),
      _: 1
    }));
  }
};
export {
  Ke as default
};
//# sourceMappingURL=datepicker.js.map
